// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { Component, Injector } from '@angular/core'; //_splitter_
import { Router } from '@angular/router'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-sideNav',
  templateUrl: './sideNav.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class sideNavComponent {
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_xVV54ZRyGF7rahkz(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_xVV54ZRyGF7rahkz(bh) {
    try {
      bh = this.sd_zIzHA4XIKnAg2Eb2(bh);
      //appendnew_next_sd_xVV54ZRyGF7rahkz
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_xVV54ZRyGF7rahkz');
    }
  }

  onNavigate(path: any = undefined, ...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = { path };
      bh.local = {};
      bh = this.sd_jOCihy2Z1eZHnsm9(bh);
      //appendnew_next_onNavigate
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_eVrdSjwAUzFPscaQ');
    }
  }

  onLogout(...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = {};
      bh.local = {};
      bh = this.sd_jBPD5FNa1BGVYbn1(bh);
      //appendnew_next_onLogout
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_qBUqH1qiV13qTcpI');
    }
  }
  //appendnew_flow_sideNavComponent_start

  sd_zIzHA4XIKnAg2Eb2(bh) {
    try {
      //appendnew_next_sd_zIzHA4XIKnAg2Eb2
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_zIzHA4XIKnAg2Eb2');
    }
  }

  async sd_jOCihy2Z1eZHnsm9(bh) {
    try {
      const { paramObj: qprm, path: path } =
        this.sdService.getPathAndQParamsObj(bh.input.path);
      await this.__page_injector__
        .get(Router)
        .navigate([this.sdService.formatPathWithParams(path, undefined)], {
          queryParams: Object.assign(qprm, ''),
        });
      //appendnew_next_sd_jOCihy2Z1eZHnsm9
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_jOCihy2Z1eZHnsm9');
    }
  }

  sd_jBPD5FNa1BGVYbn1(bh) {
    try {
      const page = this.page;
      bh.system.oauthService.logout();
      //appendnew_next_sd_jBPD5FNa1BGVYbn1
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_jBPD5FNa1BGVYbn1');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_sideNavComponent_Catch
}
